import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '../config/app-config';

/** Generates an RFC 4122 correlation id, falling back when `crypto` is unavailable. */
export function generateCorrelationId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function isApiRequest(url: string, apiBaseUrl: string): boolean {
  return url.startsWith(apiBaseUrl) || url.includes('/api/');
}

/**
 * Sends an `X-Correlation-Id` header on API requests so client activity can be
 * traced end-to-end against the server correlation-id middleware (T-060, Tech plan §6/§7).
 */
export const correlationIdInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(APP_CONFIG);
  if (!isApiRequest(req.url, config.apiBaseUrl)) {
    return next(req);
  }
  const correlationId = req.headers.get('X-Correlation-Id') ?? generateCorrelationId();
  return next(req.clone({ setHeaders: { 'X-Correlation-Id': correlationId } }));
};

/** Reads the correlation id from an HTTP error's echoed response header, if present. */
export function correlationIdFromError(error: HttpErrorResponse): string | undefined {
  return error.headers?.get('X-Correlation-Id') ?? undefined;
}
